import { collection, getDocs, query, where } from 'firebase/firestore';
import React, { useCallback, useEffect, useState } from 'react';
import { db } from '../firebase/config';

const CommentsList = ({id}) => {

     const [commentsList, setCommentsList] = useState([]);


     const fetchComments = useCallback(async () => {
          try {
               const q = query(
                    collection(db, "comments"),
                    where("problemId", "==", id)
               );

               const snapshot = await getDocs(q);

               const data = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
               }));

               setCommentsList(data);
          } catch (err) {
               console.error("Comments fetch error:", err);
          }
     }, [id]);


     useEffect(() => {
          if (id) {
               fetchComments();
          }
     }, [id, fetchComments]);

     return (
          <>
               <div className="comments-section">
                    <h3>All Comments ({commentsList.length})</h3>

                    {commentsList.length === 0 ? (
                         <p className="no-comments text-danger">No comments yet. Be the first to share your thoughts!</p>
                    ) : (
                         commentsList.map((c) => (
                              <div key={c.id} className="comment-item">
                                   <div className="comment-head">
                                        <div className="avatar">{c.userInitials}</div>
                                        <div>
                                             <h4>{c.userName}</h4>
                                             <span>
                                                  {c.createdAt?.seconds
                                                       ? new Date(c.createdAt.seconds * 1000).toLocaleString()
                                                       : "Just now"}
                                             </span>
                                        </div>
                                   </div>

                                   <p className="comment-text">{c.text}</p>
                              </div>
                         ))
                    )}
               </div>

          </>
     );
}

export default CommentsList;
